import BestPriceBadge from 'components/header/best-price-badge';
import ButtonContainer from 'core/button-container';
import dynamic from 'next/dynamic';
import FormOrRedirectButton from 'components/landing/home-landing/form-or-redirect-button/form-or-redirect-button';
import getProperty from 'utils/get-property';
import styles from 'styles/HeaderSection.module.scss';
import { SwiperQualificationStarts } from 'components/header/qualification-stars';
import { TEMPLATES_TYPES } from 'components/landing/constants';
import { useCulture } from 'context/CultureContext';
import { useMemo } from 'react';
import { usePageInfo } from 'context/PageInfoContext';
import useRichTranslation from 'hooks/useRichTranslation';

const CecaEs = dynamic(() => import('components/header/ceca-es'));
const CecaPt = dynamic(() => import('components/header/ceca-pt'));

export const Header = () => {
    const t = useRichTranslation();
    const { culture } = useCulture();
    const { pageInfo } = usePageInfo();
    const textFromMessage = [TEMPLATES_TYPES.INSURANCE_CAR,
        TEMPLATES_TYPES.INSURANCE_CAR_LANDING,
        TEMPLATES_TYPES.BLOG_POST,
        TEMPLATES_TYPES.INSURANCE_HOME].includes(pageInfo.template_type);

    const minorPrice = getProperty(
        pageInfo,
        data => pageInfo.page_context.page_dinamic_data.minor_price
    );
    const cleanTitle = (title) => {
        return title.replace('🥇', '').replace(
            '{insurance_price}',
            `${t('custom-head.money-symbol')}${minorPrice}`
        );
    };
    const title = useMemo(
        () => cleanTitle(pageInfo.page_context.title),
        [pageInfo.page_context.title]
    );

    return (
        <section className={styles.section} id="home">
            <div className={styles.first_section}>
                <div className={`${styles.content} ${textFromMessage ? styles.short_height : styles.full_height}`}>
                    <a
                        href={t('header.home-href')}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.logo_text}
                        aria-label={t('header.home-alt')}
                    >
                        {culture === 'pt-br' ?
                            (
                                <CecaPt height={60} width={180} />
                            ) :
                            (
                                <CecaEs height={60} width={180} />
                            )}
                    </a>
                    <h1 className={styles.title}>
                        {textFromMessage ? t('header.display-text.title') : title}
                    </h1>
                    <div className={styles.display_item_description}>
                        {t('header.display-text.description')}
                    </div>
                    <ButtonContainer width="auto" align="left">
                        <FormOrRedirectButton
                            label={t('header.button.label')}
                            extraProps={{
                                showLoading: true,
                                hrefTrigger: '_self'
                            }}
                            redirectWithConversio={culture === 'es-ar'}
                            href={culture === 'es-ar' ? t('header.button.href') : null}
                        />
                    </ButtonContainer>
                </div>
            </div>
            <div className={styles.second_section}>
                <div className={styles.guaranteed_icon}>
                    <BestPriceBadge />
                    <SwiperQualificationStarts />
                </div>
            </div>
        </section>
    );
};
